import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useListColumns } from 'shared/hooks/use-list-columns';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { useInsightsLifeAreas } from '../../hooks/use-insights-life-areas';
import {
  InsightsPremiumBanner,
  PremiumBannerTypes,
} from '../insights-premium-banner';
import { LifescanInsightsCard } from '../lifescan-insights-card';
import * as Styled from './lifescan-insights.style';

export const LifescanInsights: React.FC = () => {
  const widthRef = React.useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const lifeAreas = useInsightsLifeAreas();
  const { allowed } = usePremiumFeatureAllowed(LimitKeys.Insights, {});

  const listColumns = useListColumns(widthRef);

  return lifeAreas.length ? (
    <PageSectionBase
      title={t('pages.insights.sections.life-areas.title')}
      noPadding
    >
      <Styled.WidthRef ref={widthRef} />
      <Styled.List $columns={listColumns}>
        {lifeAreas.map((lifeArea) => (
          <Styled.ListItem $columns={listColumns} key={lifeArea.id}>
            <LifescanInsightsCard lifeArea={lifeArea} />
          </Styled.ListItem>
        ))}

        {!allowed && (
          <Styled.PremiumBannerContainer>
            <InsightsPremiumBanner type={PremiumBannerTypes.LifeArea} />
          </Styled.PremiumBannerContainer>
        )}
      </Styled.List>
    </PageSectionBase>
  ) : null;
};
